import { render, staticRenderFns } from "./confirmIcon.vue?vue&type=template&id=aafd952e&scoped=true&"
import script from "./confirmIcon.vue?vue&type=script&lang=js&"
export * from "./confirmIcon.vue?vue&type=script&lang=js&"
import style0 from "./confirmIcon.vue?vue&type=style&index=0&id=aafd952e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aafd952e",
  null
  
)

export default component.exports